import { VerticalDragDirection } from './mouse-drag-tracker.util';

export function getDropIndexAdjustedForDragDirection(previousIndex: number, currentIndex: number, dragDirection: VerticalDragDirection): number {

    const dragDirectionInt =
        dragDirection === 'draggingDown' ? 1 :
            dragDirection === 'draggingUp' ? -1 :
                0;
    const indexChangeDirection = Math.sign(currentIndex - previousIndex);

    const draggingTowardsPreviousIndex = dragDirectionInt != indexChangeDirection;
    if (draggingTowardsPreviousIndex) {
        const adjustmentTowardsPreviousIndex = indexChangeDirection * -1;
        return currentIndex + adjustmentTowardsPreviousIndex;
    }
    return currentIndex;
}
